import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/crm/customers/$customerId',
}).lazy(() => import('./customers.$customerId.index.lazy').then((d) => d.Route))
